import EntireApartmentHostedBySally from './homesData/EntireApartmentHostedBySally';
import EntireApartmentHostedBySeawall from './homesData/EntireApartmentHostedBySeawall';
import EntireCottageHostedByJesse from './homesData/EntireCottageHostedByJesse';
import PrivateRoomInHouseHostedBySheila from './homesData/PrivateRoomInHouseHostedBySheila';
import RoomInBoutiqueHotelHostedByTheCrafers from './homesData/RoomInBoutiqueHotelHostedByTheCrafers';
import RoomInHotelHostedByMatthew from './homesData/RoomInHotelHostedByMatthew';

const homesData = [
	// { id: 0, thumb: "thumb", img: "img", permalink: "permalink", title: "Title", city: "City", location: "Location", cost: 218, guests: 2, bedrooms: 3, beds: 3, baths: 2, reviews: 55, star: 4.44, advantage: { "advantage key": "advantage value" }, rules: "rules", content: "content" },

	EntireApartmentHostedBySally,
	EntireApartmentHostedBySeawall,
	EntireCottageHostedByJesse,
	PrivateRoomInHouseHostedBySheila,
	RoomInBoutiqueHotelHostedByTheCrafers,
	RoomInHotelHostedByMatthew
];
export default homesData;